<template>
    <ct-modal
        :title="$t('auth.ResetPasswordMax')"
        v-if="modalVisible"
        @closed="modalClose"
        class="forgot-modal"
        :class="{'forgot-modal_mobile': isMobile}"
        width="580px">
        <div slot="body">
          <ct-form ref="modalForm" :model="modal" class="modal-form" :rules="rules">
            <ct-form-item :label="$t('auth.EmailOrMobile')" prop="email">
                <ct-select
                    v-if="isLogin"
                    class="my-select"
                    width="100%"
                    v-model.trim="modal.email"
                    :selectData="accountList"
                    :method="'click'"
                    defaultText="enter your account"
                    clearable></ct-select>
                <ct-input v-else autocomplete="off" width="100%" v-model.trim="modal.email" maxlength="128" clearable placeholder="something@example.com"></ct-input>
            </ct-form-item>
            <ct-form-item :label="$t('auth.VerificationCode')" class="vc-item" prop="sms">
                <div v-show="isVerifying" id="comet-nctc" class="nc-container"></div>
                <ct-input maxlength="6" clearable class="smscodeinput" width="60%" v-model.trim="modal.sms" :placeholder="$t('auth.VerificationCodePlaceholder')"></ct-input>
                <ct-button class="sms-btn" size="medium"
                    @click.prevent="getsmsCode"
                    :disabled="smsdisabledResult"
                    :isLoading="smsLoading"  type="primary">{{ smsText }}</ct-button>
                </ct-form-item>
                <ct-form-item :label="$t('auth.CreatePassword')" prop="password" :type="false">
                <ct-icon
                    :name="resetIconName"
                    :multi-color="false"
                    class="hide-btn"
                    @click.native="toggleChange"></ct-icon>
                <input type="password" name="a" style="display:none;">
                <ct-input @on-focus="focusPwd" autocomplete="off" class="pwdInput"  maxlength="32" width="100%" v-model.trim="modal.password" :type="type" :placeholder="$t('auth.CreatePasswordPlaceholder')"></ct-input>
            </ct-form-item>
          </ct-form>
        </div>
        <div slot="footer">
          <ct-button type="primary"
            :disabled=submitdisabled
            :isLoading="submitLoading"
            @click.prevent="confirmHandle('modalForm')">{{ $t('auth.ResetPassword') }}</ct-button>
        </div>
      </ct-modal>
</template>

<script>
import i18n from '@/i18n'
import { mapGetters } from 'vuex'
import cookie from '@/utils/cookie'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isLogin: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    visible () {
      this.modalVisible = this.visible
      if (this.isLogin) {
        this.modal.email = this.profile.email || this.profile.mobile
      }
    },
    'modal.email' (val) {
      this.validateEmail({}, val, function () {})
    },
    '$i18n.locale' () {
      this.smsText = this.$t('auth.GetVerificationCode')
    }
  },
  data () {
    return {
      locale: i18n.locale,
      modalVisible: false,
      smsText: this.$t('auth.GetVerificationCode'),
      resetIconName: 'eye',
      modal: {
        email: '',
        sms: '',
        password: ''
      },
      smsdisabled: true,
      smsLoading: false,
      smsInterval: undefined,
      smsIsWaiting: false,
      validateStatus: {
        email: true,
        sms: true,
        password: true
      },
      rules: {
        email: [
          { validator: this.validateEmail, trigger: 'change' }
        ],
        sms: [
          { validator: this.validateSms, trigger: 'change' }
        ],
        password: [
          { validator: this.validatePassword, trigger: 'change' }
        ]
      },
      iconName: 'eye-close',
      num: 60,
      submitLoading: false,
      firstFocus: false,
      isVerifying: false,
      registerByEmail: true,
      isMobile: window.innerWidth <= 768
    }
  },
  computed: {
    ...mapGetters(['profile']),
    submitdisabled () {
      const a = Object.keys(this.validateStatus).every(el => {
        return !this.validateStatus[el]
      })
      return !a
    },
    smsdisabledResult () {
      return this.smsdisabled || this.smsIsWaiting
    },
    type () {
      return this.firstFocus ? this.iconName === 'eye-open' ? 'text' : 'password' : 'text'
    },
    accountList () {
      const arr = []
      if (this.profile.email) {
        arr.push(this.profile.email)
      }
      if (this.profile.mobile) {
        arr.push(this.profile.mobile)
      }
      return arr
    }
  },
  methods: {
    modalClose () {
      this.$emit('close')
      this.modalVisible = false
      this.modal = {
        email: '',
        sms: '',
        password: ''
      }
      this.$refs['modalForm'].resetFields()
    },
    focusPwd () {
      if (!this.firstFocus) this.firstFocus = true
    },
    selfToast (message, type = '') {
      this.$toast({
        message,
        type
      })
    },
    toggleChange () {
      if (this.iconName === 'eye-open') {
        this.iconName = 'eye-close'
      } else {
        this.iconName = 'eye-open'
      }
    },
    validateEmail (rule, value, cb) {
      if (value === '') {
        this.validateStatus.email = true
        this.smsdisabled = true
        cb(new Error(this.$t('auth.AccountRequired')))
      } else {
        const regEmail = /\w+@\w+\.\w+/
        const regPhone = /^1[34578]\d{9}$/

        if (regEmail.test(String(value)) && String(value).length <= 128) {
          this.smsdisabled = false
          this.validateStatus.email = false
          this.registerByEmail = true
          cb()
        } else if (regPhone.test(String(value))) {
          this.smsdisabled = false
          this.validateStatus.email = false
          this.registerByEmail = false

          cb()
        } else {
          this.smsdisabled = true
          this.validateStatus.email = true
          cb(new Error(this.$t('auth.AccountFormatErr')))
        }
      }
    },
    validateSms (rule, value, cb) {
      if (!value) {
        this.validateStatus.sms = true
        cb(new Error(this.$t('auth.VerificationCodeRequired')))
      } else {
        if (/^\d{6}$/.test(String(value))) {
          this.validateStatus.sms = false
          cb()
        } else {
          this.validateStatus.sms = true
          cb(new Error(this.$t('auth.VerificationCodeFormatErr')))
        }
      }
    },
    validatePassword (rule, value, cb) {
      if (!value) {
        this.validateStatus.password = true
        cb(new Error(this.$t('auth.CreatePasswordRequired')))
      } else {
        if (String(value).length < 8 || String(value).length > 32) {
          this.validateStatus.password = true
          cb(new Error(this.$t('auth.CreatePasswordFormatErr')))
        } else {
          this.validateStatus.password = false
          cb()
        }
      }
    },
    getsmsCode (params) {
      if (this.validateStatus.email || this.smsLoading) return
      let api = ''
      let p = {
        scene: 'resetPassword'
      }
      this.smsLoading = true

      if (this.registerByEmail) {
        api = '/passport/sendEmail'
        p.email = this.modal.email
      } else {
        api = '/passport/sendSms'
        p.mobile = this.modal.email
      }

      if (params.token) {
        p = Object.assign(params, p)
      }
      this.$http.get(api, {
        params: p
      }).then(data => {
        data = data.data
        if (data.code === 1) {
          // 成功
          this.smsLoading = false
          this.smsdisabled = true
          this.smsIsWaiting = true
          this.smsInterval = setInterval(() => {
            this.smsText = this.$t('auth.RetryAfter', { seconds: this.num })
            this.num = this.num - 1
            if (this.num < 0) {
              clearInterval(this.smsInterval)
              this.num = 60
              this.smsText = this.$t('auth.GetVerificationCode')
              this.smsIsWaiting = false
              this.$refs['modalForm'].validateField('email', info => {
                if (info) {
                  this.smsdisabled = false
                }
              })
            }
          }, 1000)
          this.$alert({
            title: '',
            message: this.$t('auth.HasSendVerificationCode')
          })
        } else if (data.code === 90103) {
          // 已注册
          this.smsLoading = false
          this.$confirm({
            message: this.$t('auth.AccountHasSignUp'),
            cancelButton: true,
            confirmButtonText: this.$t('auth.Login'),
            cancelButtonText: this.$t('common.Cancel'),
            handleAction: (confirm, resolve) => {
              if (confirm) {
                if (this.$route.query) {
                  this.$router.push({
                    name: 'Login',
                    query: this.$route.query
                  })
                } else {
                  this.$router.push('Login')
                }
              }
              resolve()
            }
          })
        } else if (data.code === 90009) {
          // 需要填验证码才能继续
          this.isVerifying = true
          const ncToken = ['FFFF000000000176A9CF', (new Date()).getTime(), Math.random()].join(':')
          if (!window.noCaptcha) {
            this.selfToast(this.$t('auth.Err3SecondsAgainLater'), 'error')
            setTimeout(() => {
              window.location.reload()
            }, 3000)
          }
          // eslint-disable-next-line camelcase
          let NC_Opt = {
            // 声明滑动验证需要渲染的目标元素ID。
            renderTo: '#comet-nctc',
            // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
            appkey: 'FFFF000000000176A9CF',
            // 使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
            scene: 'message',
            // 滑动验证码的主键，请勿将该字段定义为固定值。确保每个用户每次打开页面时，其token值都是不同的。系统默认的格式为：”您的appkey”+”时间戳”+”随机数”。
            token: ncToken,
            customWidth: '100%',
            language: 'zh',
            // 前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将请求标识（token）、会话ID（sessionid）、签名串（sig）字段记录下来，随业务请求一同发送至您的服务端调用验签。
            callback: res => {
              this.smsLoading = false
              this.getsmsCode({
                token: ncToken,
                sessionid: res.csessionid,
                sig: res.sig
              })
              this.isVerifying = false
            },
            error: s => {
              this.smsLoading = false
              this.$alert(this.$t('common.ErrAgain'))
            }
          }
          if (this.$i18n.locale !== 'zh-CH') {
            // eslint-disable-next-line new-cap
            let nc = new window.noCaptcha(NC_Opt)
            nc.upLang('cn', {
              _startTEXT: 'please press and slide to right',
              _yesTEXT: 'access',
              _error300: 'opps，something went wrong, click <a href="javascript:__nc.reset()">refresh</a> to try again',
              _errorNetwork: 'something went wrong with your network, please <a href="javascript:__nc.reset()">click here to refresh</a>'
            })
          }
        } else if (data.code === 90008) {
          // 5次验证码上限了
          this.smsLoading = false
          this.$alert(this.$t('auth.Max5timeCode'))
        } else if (data.code === 90016) {
          // 阿里验证码错误
          this.smsLoading = false
          this.$alert(this.$t('auth.LikeRobot'))
          // this.selfToast('Oops…Something is wrong, please make sure it's correct and try again later.')
        } else if (data.code === 90003) {
          this.smsLoading = false
          this.$alert(this.$t('auth.VerificationCodeError'))
        } else if (data.code === 90015) {
          this.smsLoading = false
          this.$alert(this.$t('auth.VerificationCodeHasExpired'))
        } else {
          // 失败
          this.smsLoading = false
          this.$alert(this.$t('auth.CheckInputValue'))
        }
      }).catch(() => {
        this.smsLoading = false
        this.$alert(this.$t('auth.CheckInputValue'))
      })
    },
    confirmHandle (name) {
      this.$refs[name].validate((valid) => {
        this.submitLoading = true
        if (valid) {
          let params = {
            code: this.modal.sms,
            password: this.modal.password,
            re_password: this.modal.password
          }
          if (this.registerByEmail) {
            params.email = this.modal.email
          } else {
            params.mobile = this.modal.email
          }
          this.$http.post('/passport/resetPassword', {
            ...params
          }).then(data => {
            data = data.data
            if (data.code === 1) {
              // 成功
              const domain = window.location.host.split(':')[0].split('.').splice(1).join('.')
              cookie.setCookie('Authnized', 1, '7', '.' + domain)
              // 登录成功后需要设置完善信息标识
              if (window.location.pathname.startsWith('/passport/')) {
                cookie.setCookie('showImprove', 1, '7', '.' + domain)
              }
              window.location.href = process.env.VUE_APP_DOMIN + '/live'
            } else if (data.code === 90008 || data.code === 90010) {
              // 邮件次数上限
              this.modalClose()
              this.$confirm({
                message: this.$t('auth.NoResetPasswordTime'),
                confirmButtonText: 'ok'
              })
            } else if (data.code === 90102) {
              this.validateStatus.email = false
              // 未注册
              this.selfToast(this.$t('auth.NoSignUpCheckAccount'), 'warning')
            } else if (data.code === 90006) {
              // 发邮件过于频繁
              this.selfToast(this.$t('auth.SendTwice'), 'warning')
            } else if (data.code === 90003) {
              this.selfToast(this.$t('auth.VerificationCodeError'), 'warning')
            } else if (data.code === 90015) {
              this.selfToast(this.$t('auth.VerificationCodeHasExpired'), 'warning')
            } else {
              // 其他所有错误
              this.selfToast(this.$t('auth.CheckAccount'), 'error')
            }

            this.submitLoading = false
          }).catch(() => {
            this.submitLoading = false
            this.selfToast(this.$t('common.ErrAgain'))
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .my-select {
    width: 300px;
    .ct-select-input {
        line-height: 48px;
        border: 1px solid rgba(26,61,94,.16);
        padding: 0 24px;
        &::placeholder {
          color: rgba(118,139,158,1);
          font-size: 14px;
        }
    }
}
.forgot-modal /deep/ {
  .ct-modal--title {
    font-size:20px;
    font-weight:500;
    line-height:28px;
    color: #365572;
    margin-bottom: 24px;
  }
  .ct-modal--body {
    margin-bottom: 0;
  }
  .modal-form {
    .ct-form {
      padding: 0;
      margin-bottom: 1px;
      .ct-form-item {
        line-height: 0;
        .ct-form-label {
          font-size: 14px;
        }
      }
    }
    .sms-btn {
      float: right;
      width: 39%;
    }
  }
   .vc-item {
    position: relative;

    #comet-nctc {
      position: absolute;
      width: 100%;
      height: 48px;
      left: 0;
      bottom: 40px;
      z-index: 2;
      .errloading {
        height: 48px;
        line-height: 48px;
      }
      .nc_scale {
        height: 48px;
        span {
          height: 48px;
          line-height: 48px;
          &.nc-lang-cnt {
            line-height: 32px;
          }
        }
        .btn_slide {
          height: 48px;
          line-height: 48px;
        }
        .scale_text {
          line-height: 48px;
        }
        .clickCaptcha {
          top: 48px;
        }
        .imgCaptcha {
          top: 48px;
        }
      }
    }
  }

}
.forgot-modal_mobile /deep/ {
    .ct-modal--box {
        width: 96%!important;
        .sms-btn {
            width: 60%;
            padding: 0;
        }
        .smscodeinput {
            width: 39%!important;
        }
    }
}
 @media screen and (max-width: 390px) {
.smscodeinput {
    width: calc(100% - 140px) !important;
}
}
</style>
